import {Component, Inject, Input, OnInit} from '@angular/core';
import {ConnecttocrudService} from '../connecttocrud.service';
import {ActivatedRoute, Router} from '@angular/router';
import {LeftpanelComponent, LoaderWithProgressComponent} from "../leftpanel/leftpanel.component";
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from "@angular/material";
import {ConfirmationData, ConfirmationWithoutResponseAttributesComponent} from "../devex/devex.component";
import {ConfService} from "../conf.service";
import {AccountInfoService} from '../user/account-info.service';

@Component({
    selector: 'app-docs',
    templateUrl: './docs.component.html',
    styleUrls: ['./docs.component.scss']
})
export class DocsComponent implements OnInit {

    constructor(private _service: ConnecttocrudService,
                private route: ActivatedRoute,
                public platform: LeftpanelComponent,
                private router: Router,
                public accountInfoService: AccountInfoService,
                private dialog: MatDialog,
                private confPost: ConfService) {
    }

    _terms: any;
    display = [];
    full: any;
    title: any;
    version: any;
    selected: any;
    edit = false;
    schema = {
        'title': '',
        'description': '',
        'sub_sections': []
    };
    apisByCategory: any;
    businessLogic = [];
    isToken = false;

    @Input() partner = localStorage.getItem('partner');
    @Input() account = localStorage.getItem('account');

    showDocumentation = false;
    showDocumentor = false;
    documentorData: any;
    docPartner: any;
    docAccount: any;
    docExecutor: any;
    searchText = '';

    showPage = true;
    settingsData: any;

    async ngOnInit() {
        if (this.platform.loadingForTheFirstTime === true && this.platform.loadingForTheFirstTimeCompleted === false) {
            this.platform.initialisePlatform();
        }

        if (this.platform.settingsData !== null && this.platform.settingsData !== undefined && this.platform.settingsData !== '') {
            this.settingsData = this.platform.settingsData;
        } else {
            await this.platform.getSettingsData(this.partner, this.account, false);
            this.settingsData = this.platform.settingsData;
        }

        this.getPages();

        this.getApiExecutorsByPartnerAccountType();


    }

    getPages() {
        this.display = [];
        this._service.getItemswithParameter('v1', 'services', 'services', 'documentor', 'partner=' + this.partner + '&account=' + this.account).subscribe(async response2 => {
            this.full = response2;
            if (this.full.length === 0) {
                await this.platform.postOverviewPageByDefaultIfNotExists(this.partner, this.account);
                this.getPages();
            }
            for (let i = 0; i < this.full.length; i++) {
                let flag = false;
                for (let j = 0; j < this.display.length; j++) {
                    if (this.full[i].category_name !== undefined) {
                        if (this.full[i].category_name === this.display[j].category_name) {
                            flag = true;
                            // this.display[j].category_group.push(this.full[i]);
                            let titleFlag = false;
                            for (let k = 0; k < this.display[j].category_group.length; k++) {
                                if (this.full[i].title === this.display[j].category_group[k].title ) {
                                    titleFlag = true;
                                    this.display[j].category_group[k].versions.push(this.full[i]);
                                }
                            }
                            if (!titleFlag) {
                                this.display[j].category_group.push({title: this.full[i].title, versions: [this.full[i]]});
                            }
                        }
                    } else {
                        if ('Default' === this.display[j].category_name) {
                            flag = true;
                            // this.display[j].category_group.push(this.full[i]);
                            let titleFlag = false;
                            for (let k = 0; k < this.display[j].category_group.length; k++) {
                                if (this.full[i].title === this.display[j].category_group[k].title ) {
                                    titleFlag = true;
                                    this.display[j].category_group[k].versions.push(this.full[i]);
                                }
                            }
                            if (!titleFlag) {
                                this.display[j].category_group.push({title: this.full[i].title, versions: [this.full[i]]});
                            }
                        }
                    }
                }
                if (flag === false) {
                    if (this.full[i].category_name === undefined) {
                        this.display.push({'category_name': 'Default', 'category_group': [{title : this.full[i].title, versions: [this.full[i]]}]});
                    } else {
                        this.display.push({
                            'category_name': this.full[i].category_name,
                            'category_group': [{title : this.full[i].title, versions: [this.full[i]]}]
                        });
                    }
                }
            }
            this.route.queryParams.subscribe(params => {
                this._terms = undefined;
                this.showDocumentation = false;
                this.showPage = false;
                this.showDocumentor = false;
                if (params.showDoc !== undefined) {
                    this.showDocumentation = true;
                    this.showPage = false;
                    if (!this.docPartner && !this.docAccount && !this.docExecutor) {
                        this.showPage = true;
                        this.showDocumentation = false;
                        this.title = this.full[0].title;
                        this.version = this.full[0].version;
                        this._service.getItemswithParameter('v1', 'services', 'services', 'documentor', 'title=' + this.title + '&version=' + this.version + '&partner=' + this.partner + '&account=' + this.account).subscribe(response => {
                            this._terms = response[0];
                        });
                    }
                } else if (params.title !== undefined && params.version !== undefined) {
                    this.showPage = true;
                    this.showDocumentation = false;
                    this.title = params.title;
                    this.version = params.version;
                    this._service.getItemswithParameter('v1', 'services', 'services', 'documentor', 'title=' + this.title + '&version=' + this.version + '&partner=' + this.partner + '&account=' + this.account).subscribe(response => {
                        this._terms = response[0];
                    });
                } else {
                    this.showPage = true;
                    this.showDocumentation = false;
                    if (this.full.length > 0) {
                        this.title = this.full[0].title;
                        this.version = this.full[0].version;
                        this._service.getItemswithParameter('v1', 'services', 'services', 'documentor', 'title=' + this.title + '&version=' + this.version + '&partner=' + this.partner + '&account=' + this.account).subscribe(response => {
                            this._terms = response[0];
                        });
                    }
                }
            });
        });
    }

    getMenu(val) {
        if (val != null) {
            return val.replace(/ /g, '');
        } else {
            return 'Default';
        }
    }

    clickmenu(event) {
        this.isToken = !this.isToken;
    }

    updateDocumentaionVisibility(versions, show, versionPayload) {
        const promises = [];
        for (const version of versions) {
            if (!show) {
                promises.push(this.updateDocumentWithPublishFlag({isPublished: false}, version.id));
            } else {
                if (versionPayload.id) {
                    if (version.id === versionPayload.id) {
                        if (!version.isPublished) {
                            promises.push(this.updateDocumentWithPublishFlag({isPublished: true}, version.id));
                        }
                    } else {
                        if (version.isPublished) {
                            promises.push(this.updateDocumentWithPublishFlag({isPublished: false}, version.id));
                        }
                    }
                }
            }
        }
        Promise.all(promises)
            .then(async (results) => {
                if (show) {
                    this.platform.openSnackBar('Default version updated successfully. ' , 'Success', {
                        duration: 5000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                } else {
                    this.platform.openSnackBar('Document unpublished successfully.', 'Success', {
                        duration: 5000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                }
                this.getPages();
            });
    }

    isDocumentHidden(versions) {
        let isHidden = true;
        for (const version of versions) {
            if (version.isPublished) {
                isHidden = false;
            }
        }
        return isHidden;
    }

    updateDocumentWithPublishFlag(payload, id) {
        return new Promise(async (resolve, reject) => {
            if (id !== null && id !== undefined && id > -1) {
                this.confPost.patchItemServices('v1', 'documentor', payload, id).subscribe(success => {
                    // this.platform.openSnackBar('Page published successfully', 'Success', {
                    //     duration: 3000,
                    //     verticalPosition: 'top',
                    //     horizontalPosition: 'center'
                    // });
                    resolve('success');
                }, error => {
                    this.platform.handleErrorGracefully(error, 'Error while publishing the page');
                    reject(error);
                });
            } else {
                reject({'message': 'id cannot be empty.'});
            }
        });
    }

    enableDocument(executor, action) {
        const loaderDialog = this.dialog.open(LoaderWithProgressComponent, {
            width: 'auto',
            height: 'auto',
        });
        this.confPost.getApiExecutorByPartnerAccountEntityVersion(this.partner, this.account, executor['executor_name'], executor['executor_version']).subscribe(data => {
            if (data) {
                data['isDocumentationPublished'] = action;
                const id = data['id'];
                delete data['id'];
                this.confPost.updateApiExecutorForPartnerAccount(this.partner, this.account, id, data).subscribe(result => {
                    executor['isDocumentationPublished'] = action;
                    const actionText = action ? 'published' : 'unpublished';
                    this.platform.openSnackBar('Documentation ' + actionText + ' successfully.', 'Success', {
                        duration: 3000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                    loaderDialog.close();
                }, error => {
                    this.platform.openSnackBar('Unable to hide documentation. Please try again after some time.', 'Error', {
                        duration: 3000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                    loaderDialog.close();
                });
            } else {
                this.platform.openSnackBar('Unable to hide documentation. Please try again after some time.', 'Error', {
                    duration: 3000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
                loaderDialog.close();
            }
        }, error => {
            this.platform.handleErrorGracefully(error, 'Unable to hide documentation. Please try again after some time.');
            loaderDialog.close();
        });
    }

    deletePage(id) {
        if (confirm('This action is irreversible. Do you still want to delete this page ?')) {
            this._service.deleteItem(id.toString(), 'v1', 'services', 'services', 'documentor').subscribe(resp => {
                this.getPages();
                this.router.navigateByUrl('/docs');
                this.platform.openSnackBar('Page has been deleted successfully.', 'Success', {
                    duration: 3000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
            }, error => {
                this.platform.handleErrorGracefully(error, 'Error while deleting the page. Please try again after sometime');
            });
        }
    }

    dropdownToggle(id) {
        document.getElementById(id).classList.toggle('show');
    }

    onUpdate() {
        this.showDocumentor = false;
        this.showDocumentation = true;
        this.getPages();
        // this.router.navigateByUrl('/docs?title=');
        setTimeout(() => {
            this.router.navigateByUrl('/docs?title=' + this.documentorData.title + '&version=' + this.documentorData.version);
        }, 500);
    }

    editPage(item) {
        // const dialogRef = this.dialog.open(AddPageComponent, {
        //   width: '90%',
        //   height: '90%',
        //   data: {
        //     title: item.title,
        //     description: item.description,
        //     category_name: item.category_name,
        //     category_group: item.category_group,
        //     sections: item.sections,
        //     isEdit: true,
        //     id: item['id']
        //   }
        // });
        //
        // dialogRef.afterClosed().subscribe(response => {
        //   if (response && response === 'success') {
        //     this.getPages();
        //     this.router.navigateByUrl('/docs');
        //   }
        // })

        this.documentorData = {
            title: item.title,
            version: item.version,
            description: item.description,
            category_name: item.category_name,
            category_group: item.category_group,
            sections: item.sections,
            isEdit: true,
            isPublished: item.isPublished !== null ? item.isPublished : false,
            id: item['id']
        };

        this.showPage = false;
        this.showDocumentation = false;
        this.showDocumentor = true;
    }

    addPageUnderNewCategory() {
        const dialogRef = this.dialog.open(AddPageComponent, {
            width: '90%',
            height: '90%',
            data: {
                title: '',
                description: '',
                category_name: '',
                category_group: '',
                sections: [
                    {
                        title: '',
                        description: '',
                        sub_sections: [],
                    }
                ],
                isEdit: false
            }
        });

        dialogRef.afterClosed().subscribe(response => {
            if (response && response.hasOwnProperty('status') && response['status'] === 'success') {
                if (response.hasOwnProperty('data') && response['data']) {
                    this.getPages();
                    this.router.navigateByUrl('/docs?title=' + response['data']['title']);
                }
            }
        })
    }

    addPage(item) {
        const dialogRef = this.dialog.open(AddPageComponent, {
            width: '90%',
            height: '90%',
            data: {
                title: '',
                version: '',
                description: '',
                category_name: item.category_name,
                category_group: '',
                sections: [
                    {
                        title: '',
                        description: '',
                        sub_sections: [],
                    }
                ],
                isEdit: false,
            }
        });

        dialogRef.afterClosed().subscribe(response => {
            if (response && response.hasOwnProperty('status') && response['status'] === 'success') {
                if (response.hasOwnProperty('data') && response['data']) {
                    this.getPages();
                    this.router.navigateByUrl('/docs?title=' + response['data']['title'] + '&version=' + response['data']['version']);
                }
            }
        });
    }

    clickedSubCategory(partner, account, executor) {
        this.docPartner = partner;
        this.docAccount = account;
        // this.docExecutor = executor;
        this.docExecutor = null;
        const loaderDialog = this.dialog.open(LoaderWithProgressComponent, {
            width: 'auto',
            height: 'auto',
        });
        this.confPost.getApiExecutorByPartnerAccountEntityVersion(partner, account, executor['executor_name'], executor['executor_version']).subscribe(data => {
            if (data) {
                loaderDialog.close();
                this.docExecutor = data;
                this.router.navigateByUrl('/docs?showDoc=' + executor['executor_name']);
            } else {
                this.platform.openSnackBar('Error while retrieving the API', 'Error', {
                    duration: 3000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
                loaderDialog.close();
            }
        }, error => {
            loaderDialog.close();
            this.platform.handleErrorGracefully(error, 'Error while retrieving the API');
        });
    }

    async getApiExecutorsByPartnerAccountType() {

        if (this.platform.partnerExecutors !== null && this.platform.partnerExecutors !== undefined && this.platform.partnerExecutors.length > 0) {
            this.apisByCategory = this.platform.partnerExecutors;
        } else {
            await this.platform.getExecutorsForPartnerAccount().then(resp => {
                this.apisByCategory = this.platform.partnerExecutors;
            });
        }

        if (this.apisByCategory) {
            for (let i = 0; i < this.apisByCategory.length; i++) {
                const tempapis = [];
                for (let j = 0; j < this.apisByCategory[i]['executors'].length; j++) {
                    let temp: string;
                    temp = '';
                    // temp = '';
                    // if (this.apisByCategory[i]['executors'][j]['executor_type'] !== 'THIRDPARTY') {
                    tempapis.push(this.apisByCategory[i]['executors'][j]);
                    // }
                }
                if (tempapis.length > 0) {
                    this.businessLogic.push({'executors': tempapis, 'category': this.apisByCategory[i]['category']});
                }
            }
        }

        // this.confPost.getApiExecutorsForPartnerAccount(this.partner, this.account).subscribe(data => {
        //   this.apisByCategory = data;
        //   for ( let i = 0 ; i < this.apisByCategory.length ; i++) {
        //     let tempapis = [];
        //     for ( let j = 0 ; j <  this.apisByCategory[i]['executors'].length ; j++) {
        //       let temp: string;
        //       temp = '';
        //       // temp = '';
        //       if (this.apisByCategory[i]['executors'][j]['executor_type'] !== 'THIRDPARTY') {
        //         tempapis.push(this.apisByCategory[i]['executors'][j]['executor_name'] + '#' + this.apisByCategory[i]['executors'][j]['executor_version']  + '#' + this.apisByCategory[i]['executors'][j]['executor_method_type']);
        //       }
        //     }
        //     if (tempapis.length > 0) {
        //       this.businessLogic.push({'executors': tempapis, 'category': this.apisByCategory[i]['category']});
        //     }
        //   }
        // });
    }

    stringifyjson(val) {
        return JSON.stringify(val);
    }
}

@Component({
    selector: 'app-add-page',
    templateUrl: 'add-page.component.html',
    styleUrls: ['add-page.component.css']
})

export class AddPageComponent implements OnInit {

    constructor(
        public platform: LeftpanelComponent,
        public dialogRef: MatDialogRef<AddPageComponent>,
        @Inject(MAT_DIALOG_DATA) public data: ConfirmationData) {
    }

    confirmation: string;

    ngOnInit(): void {
    }

    closeDialog(event) {
        this.dialogRef.close(event);
    }

    onNoClick(): void {
        this.dialogRef.close();
    }

    close() {
        this.dialogRef.close();
    }

}
